import { LimitType } from "model/schema/globalTypes";
import { ServiceProductCreatable } from "../types";

// build ServiceProductCreatable payload
export function buildServiceProductPayload(
  values: Partial<ServiceProductCreatable>
): ServiceProductCreatable {
  const defaultValues: ServiceProductCreatable = {
    apiKeyId: "",
    name: "",
    limitType: LimitType.Hard,
    transactionLimit: 0,
    periods: [],
    services: [],
    notificationTriggers: []
  };
  return { ...defaultValues, ...values };
}

// Returns the first day of the month at midnight UTC for a given Date
export function getMonthStartDate(date: Date, addMonths: number = 0): Date {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error("Invalid date: expected a Date object.");
  }
  return new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth() + addMonths,
      1,
      0,
      0,
      0,
      0
    )
  );
}

// Returns the first day of the next month at midnight UTC for a given Date
export function getMonthEndDate(date: Date): Date {
  return getMonthStartDate(date, 1);
}

// Returns a list of Periods with start and end dates for each month provided by getMonthStartDate and getMonthEndDate for given startYearMonthString and endYearMonthString
export function getMonthlyPeriods(
  startDate: Date,
  endDate: Date
): { startDate: Date; endDate: Date }[] {
  const start = getMonthStartDate(startDate);
  const end = getMonthEndDate(getMonthStartDate(endDate));
  const periods: { startDate: Date; endDate: Date }[] = [];

  let current = start;
  while (current < end) {
    const next = getMonthEndDate(current);
    periods.push({ startDate: current, endDate: next });
    current = next;
  }

  return periods;
}
